import { MissingRequiredParameterError } from './errors';
import { commonIntegrationDataToQuery, integrationDataFromQuery } from './integration-data';
export function checkoutDataFromQuery(query) {
  const planId = query.get('planId') ?? undefined;
  const planSlug = query.get('planSlug') ?? undefined;
  const {
    navigateTo,
    navigateToPageProps,
    navigateToSectionProps,
    maxStartDate,
    minStartDate,
    biOptions,
    verticalStatusContent
  } = integrationDataFromQuery(query);
  const base = {
    navigateTo,
    navigateToPageProps,
    navigateToSectionProps,
    minStartDate,
    maxStartDate,
    biOptions,
    verticalStatusContent,
    memberId: query.get('memberId') ?? undefined,
    orderId: query.get('orderId') ?? undefined
  };
  if (planId) {
    return {
      ...base,
      planId,
      planSlug: undefined
    };
  } else if (planSlug) {
    return {
      ...base,
      planId: undefined,
      planSlug
    };
  } else {
    throw new MissingRequiredParameterError('planId', 'planSlug');
  }
}
export function checkoutDataToQuery(data) {
  const query = commonIntegrationDataToQuery(data.integrationData);
  query.set('planId', data.planId);
  data.memberId && query.set('memberId', data.memberId);
  data.orderId && query.set('orderId', data.orderId);
  return query;
}
//# sourceMappingURL=checkout-data.js.map